<div attr.tid="{{childConfig.config.controlName}}" class="ct-divider" [style.width.px]="childConfig.css.width">
    <span class="line"></span>
    <span class="txt" *ngIf="!childConfig.config.isLabelHidden">{{childConfig.config.controlName}}</span>
    <span class="line"></span>
</div>